import { APP_INITIALIZER, inject, Injectable, Provider } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { filter } from "rxjs";
import IframeUtil from "../Utils/IframeUtil";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
/**
 * Serviço para concentrar as rotas de contagem de acessos para formulação de métricas
 */
export class AnalyticsService {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private http = inject(HttpClient);

  init() {
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
      )
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects;
        if (this.isPaginaSumario(url)) {
          this.trackAcessoSumario();
        }
      });
  }

  private trackAcessoSumario(): void {
    const origem: "P001" | "menu" | "externo" = IframeUtil.inIframe
      ? "P001" // componente compartilhado (lupa)
      : (this.route.snapshot.queryParams["origem"] ?? // menu de ações
        "externo"); // link externo

    const url = `${environment.appContext}/api/acessos/incluir`;
    this.http.get(url, { params: { origem } }).subscribe();
  }

  private isPaginaSumario(url) {
    return /^\/sumario/.test(url);
  }
}
export function provideClsfAnalyticsRouterTracker(): Provider {
  return {
    provide: APP_INITIALIZER,
    useFactory: () => {
      const analytics = inject(AnalyticsService);
      return () => analytics.init();
    },
    multi: true,
  };
}
